import { FC } from 'react';

import styles from 'components/Sections/ExponeaPsychicProfile/ExponeaPsychicProfile.module.scss';

import type { IEstimationComponent } from './config/declarations';

const getTimeString = (estimatedTime: number): string => {
  if (estimatedTime >= 59) {
    const hours = Math.floor(estimatedTime / 60);
    const minutes = estimatedTime % 60;
    const minutesPart = minutes !== 0 ? `${minutes} min` : '';

    return `${hours}h ${minutesPart}`.trim();
  }

  return `${estimatedTime}`;
};

const EstimatedTime: FC<IEstimationComponent> = ({
  texts,
  timeUnit,
  isShortText = false,
  estimatedTime,
}) => {
  const textsArray = texts?.split('-') || [];
  const text = (isShortText ? textsArray[0] : textsArray[1]) || '';

  return (
    <div className={styles.estimation}>
      <strong className={styles.estimationTitle}>{text}</strong>
      <span className={styles.estimationValue}>
        {getTimeString(estimatedTime)}
        {' '}
        {estimatedTime <= 59 && timeUnit}
      </span>
    </div>
  );
};

export default EstimatedTime;
